import './careers.css';
import React from 'react';

const OperationsText = () => {
  return (
    <p className="text">
      Our operations team builds centralized connected smart hubs to enable
      efficient vehicle maintenance, repair and charging. Our connected
      smart hubs are crucial for managing and scaling large fleets of
      electric vehicles.
    </p>
  );
};

export default OperationsText;



// WEBPACK FOOTER //
// ./src/components/Careers/OperationsText.js